@if (dataVisualization && dataVisualization.expressionValues.length > 1) {
    @switch (dataVisualization.definition.representation) {
        @case ('spiderChart') {
            <app-spider-chart-data-visualization [dataVisualization]="dataVisualization"
                                                 [hideLabels]="hideLabels" />
        }

        @case ('shareDonutChart') {
            <app-doughnut-chart-data-visualization [dataVisualization]="dataVisualization" />
        }
    }
}
